import React from 'react'
import { ReferenceArrayField, SingleFieldList, ChipField } from 'react-admin'
import { Entity } from '@obvious.tech/constellation/Entity'

export default ({ name, property, ...props }) => {
  return (
    <ReferenceArrayField
      {...props}
      label={property.displayedName || name}
      source={name}
      reference={Entity.getResource(property.reference?.target)}
    >
      <SingleFieldList>
        <ChipField source={property.reference?.targetLabelKeyPath} />
      </SingleFieldList>
    </ReferenceArrayField>
  )
}
